interface LocalStorageData<T> {
    d: T
}

const transientStorage: {[key: string]: any} = {};

class LocalStorageServiceClass {
    constructor(){
        this.localStorageSupported = !!window.localStorage;
    }

    public get<T>(key: string): T | undefined {
        if(this.localStorageSupported) {
            const data = window.localStorage.getItem(key);
            return !!data ? (JSON.parse(data) as LocalStorageData<T>).d : undefined;
        }
        else {
            return transientStorage[key]?.d as T | undefined;
        }
    }

    public set<T>(key: string, data:T) {
        const dataContainer:LocalStorageData<T> = {d: data};

        if(this.localStorageSupported) {
            window.localStorage.setItem(key, JSON.stringify(dataContainer));
        }
        else {
            transientStorage[key] = dataContainer;
        }

        return data;
    }

    public clear(key: string) {
        if(this.localStorageSupported) {
            window.localStorage.removeItem(key);
        }
        else if (!!transientStorage[key]) {
            transientStorage[key] = undefined;
        }
    }

    private localStorageSupported: boolean;
}

export const LocalStorageService = new LocalStorageServiceClass();